import * as Joi from 'joi';

export const ForgetPasswordSchema = Joi.object({
  email: Joi.string().trim().max(100).required().messages({
    'any.required': 'Email address is required.',
    'string.base': 'Email address is required.',
    'string.empty': 'Email address is required.',
    'string.min': 'Email address can be at most 100 characters only.',
    'string.max': 'Email address can be at most 100 characters only.',
  }),
  username: Joi.string().trim().min(1).max(50).required().messages({
    'any.required': 'Username is required.',
    'string.base': 'Username is required.',
    'string.empty': 'Username is required.',
    'string.min': 'Username can be at most 50 characters only.',
    'string.max': 'Username can be at most 50 characters only.',
  }),
});
